<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <el-menu
        :default-active="defaultActive"
        :default-openeds="['监测管理']"
        unique-opened
        text-color="#54667a"
        active-text-color="#3c8dbc"
        router
      >
        <div v-for="row in permissionRouters" :key="row.path">
          <!-- 表示有二级菜单 -->
          <template v-if="!row.hidden && !row.noDropdown">
            <el-submenu :index="row.meta.title" v-if="row.children">
              <template slot="title">
                <i :class="row.meta.icon" :style="row.meta.style ? row.meta.style : {}"></i>
                <span>{{row.meta.title}}</span>
              </template>
              <el-menu-item-group v-for="child in row.children" :key="child.name">
                <template v-if="!child.hidden">
                  <el-menu-item
                    :index="`${row.path}/${child.path}`">
                    <span>{{child.meta.title}}</span>
                  </el-menu-item>
                </template>
              </el-menu-item-group>
            </el-submenu>
          </template>
          <!-- 只有一级菜单 -->
          <template v-if="!row.hidden && row.noDropdown">
            <el-menu-item :index="`${row.path}/${row.children[0].path}`">
              <i :class="row.meta.icon"></i>
              <span slot="title">{{row.meta.title}}</span>
            </el-menu-item>
          </template>
        </div>
      </el-menu>
    </section>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex';
  export default {
    data() {
      return {
        defaultActive: '/project/list'
      };
    },
    computed: {
      ...mapGetters(['permissionRouters'])
    },
    mounted() {
      this.defaultActive = this.$route.path;
    },
    methods: {}
  };
</script>

<style lang="scss" scoped>
  .iconfont {
    font-size: 1.8em;
    padding-right: 5px;
  }
  div {
    li {
      span {
        font-size: 1.2em;
        font-weight: 700;
      }
    }
    /deep/ .el-menu {
      border-right: none;
    }
    /deep/ .el-menu-item-group {
      .el-menu-item-group__title {
        padding: 0;
      }
      .el-menu-item {
        span {
          font-weight: normal;
        }
      }
    }
    /deep/ .el-icon-arrow-down {
      font-size: 1.4em;
    }
  }
  .el-icon-setting {
    font-size: 24px;
  }
  .main-sidebar {
    position: fixed;
    height: 100%;
    overflow: auto;
    -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
    box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  }

  @media screen and (max-width: 768px) {
    .main-sidebar, .left-side {
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/main-sidebar.vue